<template>
  <li class="solution-main-content-d-ul-li" @mouseenter="show=false"
      @mouseleave="show=true" >
    <img v-show="show" :src="imgurl" alt="">
    <div class="solution-main-content-d-ul-li-all">
      <p class="solution-main-content-d-ul-li-title">{{title}}</p>
      <p class="solution-main-content-d-ul-li-text">
        {{text}}</p>
    </div>
  </li>
</template>

<script>
export default {
  name: "solutionItem",
  props:['title','text','imgurl'],
  data(){
    return {
      show:true
    }
  }
}
</script>

<style scoped>
.solution-main-content-d-ul-li {
  width: 280px;
  height: 294px;
  background: #ffffff;
  margin-top: 20px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  margin-right: 15px;
  overflow: hidden;
}
.solution-main-content-d-ul-li:hover {
  cursor: pointer;
  background-color: #77ba00;
}
.solution-main-content-d-ul-li:hover p {
  color: #fff !important;
}
.solution-main-content-d-ul-li img {
  width: 280px;
  height: 168px;
  transition: all 0.5s;
}
.solution-main-content-d-ul-li img:hover {
  transform: scale(1.2, 1.2);
}
.solution-main-content-d-ul-li-all {
  padding: 16px;
}
.solution-main-content-d-ul-li-title {
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}
.solution-main-content-d-ul-li-text {
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.solution-main-content-d-ul-li:hover{
  cursor: pointer;
  background-color: #77BA00;
}
.solution-main-content-d-ul-li:hover p{
  color:#FFF!important;
  overflow:visible;
}
</style>